<template>
  <project-template title="选择研究病种" nextBtnText="下一步：病种模块" @lastClick="lastClick" @nextClick="nextClick">

    <template v-slot:leftContent>
      <div class="small-title">
        <img :src="require('@/assets/icon_sick.png')" alt="">
        已选择病种
      </div>
      <!-- start -->
      <div class="project-template2-card">
<!-- 
        <div class="info-mini-title">
          主病种
        </div> -->
        <template v-for="(item, index) in checkData">
          <div v-if="item.diseaseList.filter(list => list.main == true).length > 0" class="project-disease-check"
            style="margin-top: 10px" :key="index">
            <div class="title1">
              <component :is="'icon-gk'"></component>
              <h2>{{ item.name }}</h2>
              <span>已选 {{ item.diseaseList.filter(list => list.main == true).length }}个</span>
            </div>
            <div class="list" v-if="checkData.length > 0">
              <div class="item" v-for="(item1, index) in item.diseaseList.filter(list => list.main == true)"
                :key="index">
                <a-checkbox :value="item1" :checked="true" disabled>
                  <em>{{ item1.name }}</em>
                </a-checkbox>
              </div>
            </div>
          </div>
        </template>
        <div v-if="checkData.length === 0" class="info-title info-title-no" style="text-align: center;">
          您还没有添加病种
        </div>
        <!-- <template v-for="(item, index) in diseaseSelected1List">
          <div class="info-title info-title-disease1 " v-if="item.main" :key="index">
            <a-icon type="delete" @click.stop="deleteDisease(true)" class="delete" />
            <div style="text-align: center">
              <a-icon type="align-center" class="icon-big" />
              <div class="info-title-name">
                <strong style="font-size: 18px">
                  {{ item.name }}
                </strong>
              </div>
            </div>
          </div>
        </template>
<div v-if="diseaseSelected1List.length == 0" class="info-title info-title-no" style="text-align: center;">
  您还没有添加主病种
</div>-->

        <!-- <div style="margin-top: 20px;" v-if="model.manyType === '1'">
          <div class="info-mini-title">
            次病种
          </div>
          <template v-for="(item, index) in checkData">
            <div v-if="item.diseaseList.filter(list => list.main == false).length > 0" class="project-disease-check"
              style="margin-top: 10px" :key="index">
              <div class="title1" v-if="item.diseaseList.filter(list => list.main == false).length > 0">
                <component :is="'icon-gk'"></component>
                <h2>{{ item.name }}</h2>
                <span>已选 {{ item.diseaseList.filter(list => list.main == false).length }}个</span>
              </div>
              <div class="list" v-if="item.diseaseList.filter(list => list.main == false).length > 0">
                <div class="item" v-for="(item1, index) in item.diseaseList.filter(list => list.main == false)"
                  :key="index">
                  <a-checkbox :value="item1" :checked="true" disabled>
                    <em>{{ item1.name }}</em>
                  </a-checkbox>
                </div>
              </div>
            </div>
          </template>
          <div class="info-title2" :key="index" v-for="(item, index) in diseaseSelected2List">
            <a-icon type="delete" @click.stop="deleteDisease(false)" class="delete" />
            <div :key="index" class="info-title-center">
              <a-icon type="align-center" class="icon-big" />
              <div class="info-title-name">
                {{ item.name }}
              </div>
            </div>
          </div>
          
          <div v-if="checkData.slice(1).length == 0" class="info-title info-title-no" style="text-align: center;">
            您还没有添加次病种
          </div>
        </div> -->
      </div>
      <!-- end -->
    </template>

    <template v-slot:rightContent>
      <!-- <disease ref="disease" :project="model" @submit="addDisease"></disease> -->

       <div class="search-panel">
        <a-input v-model="keyword" class="search-input" placeholder="请输入研究病种关键字进行查询"
          style="width: 400px;margin-right:10px"></a-input>
        <a-button size="small" @click="search" :disabled="model.confirm === '0'">查询</a-button>
      </div> 

      <div class="temp2-disease-title">
            为您推荐病种
          </div>
          <div v-if="subMajorKeyWords.length == 0" class="info-title info-title-no" style="text-align: center;">
            暂无推荐
          </div>
          <div v-else class="gauge" style="margin-top: 10px" v-for="(item, index) in subMajorKeyWords">
            <div class="title1">
              <component :is="isRegistered(item.icon) ? item.icon : 'icon-gk'"></component>
              <h2>{{ item.name }}</h2>
              <span>已选 {{ item.diseaseList.filter(list => list.checked).length }} 个</span>
              <div class="select-all">
                <a-checkbox
                  :indeterminate="!!item.diseaseList.filter(list => list.checked).length && item.diseaseList.filter(list => list.checked).length < item.diseaseList.length"
                  :checked="item.diseaseList.filter(list => list.checked).length === item.diseaseList.length"
                  @change="onCheckAllChange(item.diseaseList, $event, true)" :disabled="model.confirm === '0'">
                  全选
                </a-checkbox>
              </div>
            </div>

            <a-collapse v-model="activeKey" @change="changeActivekey" class="project-collapse">
              <a-collapse-panel :key="item.id" header="研究病种" :disabled="model.confirm === '0'">
                <div class="list">
                  <div v-for="(disease, index) in item.diseaseList" :key="index">
                    <div class="item" v-if="disease.isFirst === '1'">
                      <a-checkbox :value="disease" @change="onChange(disease, $event, true)" :checked="disease.checked">
                        <em>
                          {{ disease.name }}
                        </em>
                      </a-checkbox>
                    </div>
                  </div>
                </div>
              </a-collapse-panel>
            </a-collapse>

          </div>

          <div class="temp2-disease-title">
            选择其它病种
          </div>

          <div class="gauge" style="margin-top: 10px"
            v-for="(item, index) in subMajor.filter(items => items.deptIds == depts[0].id)" :key="index">
            <div class="title1">
              <component :is="isRegistered(item.icon) ? item.icon : 'icon-gk'"></component>
              <h2>{{ item.name }}</h2>
              <span>已选 {{ item.diseaseList.filter(list => list.checked).length }} 个</span>
              <div class="select-all">
                <a-checkbox
                  :indeterminate="!!item.diseaseList.filter(list => list.checked).length && item.diseaseList.filter(list => list.checked).length < item.diseaseList.length"
                  :checked="item.diseaseList.filter(list => list.checked).length === item.diseaseList.length"
                  @change="onCheckAllChange(item.diseaseList, $event, true)" :disabled="model.confirm === '0'">
                  全选
                </a-checkbox>
              </div>
            </div>
            <a-collapse v-model="activeKey" @change="changeActivekey" class="project-collapse">
              <a-collapse-panel :key="item.id" header="研究病种" :disabled="model.confirm === '0'">
                <div class="list">
                  <div v-for="(disease, index) in item.diseaseList" :key="index">
                    <div class="item" v-if="disease.isFirst === '0'">
                      <a-checkbox :value="disease" @change="onChange(disease, $event, true)" :checked="disease.checked">
                        <em>
                          {{ disease.name }}
                        </em>
                      </a-checkbox>
                    </div>
                  </div>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </div>

      <!-- <a-tabs v-model="customActiveKey" :tabBarStyle="{ textAlign: 'left', borderBottom: 'unset' }" type="card">
        <a-tab-pane key='1' tab="主病种">
      
        </a-tab-pane>

        <a-tab-pane key='2' tab="次病种">

          <div class="temp2-disease-title">
            选择研究次病种
          </div>

          <div class="gauge" style="margin-top: 10px" v-for="(item, index) in subMajor">
            <div class="title1">
              <component :is="isRegistered(item.icon) ? item.icon : 'icon-gk'"></component>
              <h2>{{ item.name }}</h2>
              <span>已选 {{ item.diseaseList.filter(list => list.checked).length }} 个</span>
              <div class="select-all">
                <a-checkbox
                  :indeterminate="!!item.diseaseList.filter(list => list.checked).length && item.diseaseList.filter(list => list.checked).length < item.diseaseList.length"
                  :checked="item.diseaseList.filter(list => list.checked).length === item.diseaseList.length"
                  @change="onCheckAllChange(item.diseaseList, $event, false)" :disabled="model.confirm === '0'">
                  全选
                </a-checkbox>
              </div>
            </div>
            <a-collapse v-model="activeKey" @change="changeActivekey" class="project-collapse">
              <a-collapse-panel :key="item.id" header="研究病种" :disabled="model.confirm === '0'">
                <div class="list">
                  <div v-for="(disease, index) in item.diseaseList" :key="index">
                    <div class="item" v-if="disease.isFirst === '0'">
                      <a-checkbox :value="disease" @change="onChange(disease, $event, false)" :checked="disease.checked"
                        :disabled="disease.checked === true && disease.main == true">
                        <em>
                          {{ disease.name }}
                        </em>
                      </a-checkbox>
                    </div>
                  </div>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </div>


        </a-tab-pane>
      </a-tabs> -->


    </template>
  </project-template>
</template>

<script>
import Vue from 'vue'
import { getAction, postAction } from '@/api/manage'
import Dept from './projectTemplate2/Dept'
import Disease from './projectTemplate2/Disease'
import Module from './projectTemplate2/Module'
import ModuleForm from './projectTemplate2/ModuleForm'
import ModuleFormDiy from './projectTemplate2/ModuleFormDiy'
import ProjectTemplate from '@comp/pad/ProjectTemplate'

export default {
  name: 'StepTwo',
  components: { ModuleFormDiy, ModuleForm, Module, Disease, Dept, ProjectTemplate },
  data() {
    return {
      model: {},
      deptSelectedList: [],
      diseaseSelectedList: [],
      subMajor: [],
      subMajorCopy:[],
      subMajorKeyWords: [],
      checkList: [],//已选择的病种列表
      activeKey: ['1'],
      checkData: [],//已选择的亚专业---病种列表（按亚专业分组）
      deptIds: '',
      depts: [],
      keyword: '',
      loading: true,
      isok: true,
      customActiveKey: '1',
    }
  },
  computed: {
    moduleJson() {
      if (this.model.moduleJson) {
        return JSON.parse(this.model.moduleJson)
      }
      return {}
    },
    diseaseSelected1List() {
      const result = []
      this.diseaseSelectedList.forEach(item => {
        if (item.main) {
          result.push(item)
        }
      })
      return result
    },
    diseaseSelected2List() {
      const result = []
      this.diseaseSelectedList.forEach(item => {
        if (!item.main) {
          result.push(item)
        }
      })
      return result
    }
  },
  mounted() {
    this.loadProjectData()
  },
  methods: {
    changeActivekey(a) {
      console.log('a', JSON.parse(JSON.stringify(a)))
    },
    isRegistered(componentName) {
      return !!Vue.options.components[componentName]
    },
    onCheckAllChange(disease, e, isMain) {
      disease.forEach(item => {
        item.checked = e.target.checked
        if (isMain) {
          item.main = true;
        } else {
          item.main = false;
        }
      })
      if (e.target.checked) {
        if (this.checkList.length === 0) {
          this.checkList = JSON.parse(JSON.stringify(disease))
        } else {
          disease.forEach((item1, index) => {
            let flag = true
            item1.checked = true
            this.checkList.forEach(item2 => {
              if (item1.id === item2.id) {
                flag = false
              }
            })
            if (flag) this.checkList.push(disease[index])
          })
        }
        this.checkData = this.checkData.filter(item => item.name !== disease[0].submajorName)

        let temp = { name: disease[0].submajorName }
        temp.diseaseList = disease
        this.checkData.push(temp)
      } else {
        const arr = JSON.parse(JSON.stringify(this.checkList))
        disease.forEach(item1 => {
          for (let n = arr.length - 1; n >= 0; n--) {
            if (item1.id === arr[n].id) {
              arr.splice(n, 1)
            }
          }
        })
        this.checkList = arr
        this.checkData = this.checkData.filter(item => item.name !== disease[0].submajorName)
      }
    },
    onChange(disease, e, isMain) {
      disease.checked = e.target.checked
      if (e.target.checked) {
        if (isMain) {
          disease.main = true;
        } else {
          disease.main = false;
        }
        this.checkList.push(disease)
        let isExist = this.checkData.filter(item => item.name === disease.submajorName)
        if (isExist.length > 0) {
          isExist[0].diseaseList.push(disease)
        } else {
          let diseaseList = []
          diseaseList.push(disease)
          let temp = { name: disease.submajorName }
          temp.diseaseList = diseaseList
          this.checkData.push(temp)
        }
      } else {
        this.checkList = this.checkList.filter(item => item.id !== disease.id)
        let major = this.checkData.filter(item => item.name === disease.submajorName)
        major[0].diseaseList = major[0].diseaseList.filter(item => item.id !== disease.id)
        if (major[0].diseaseList.length === 0) {
          this.checkData = this.checkData.filter(item => item.name !== disease.submajorName)
        }
      }
    },
    checked(checkList) {
      this.checkList = checkList
    },
    deleteDisease(flag) {
      this.$confirm({
        title: '删除病种',
        content: (<div>
          <p>您确定要删除这个病种吗？</p>
        </div>),
        centered: false,
        onOk: () => {
          let n = 0
          this.diseaseSelectedList.find((item, index) => {
            if (item.main === flag) {
              n = index
            }
          })
          this.diseaseSelectedList.splice(n, 1)
        }
      })
    },
    getModuleLength(disease) {
      if (this.moduleJson[disease.code]) {
        return this.moduleJson[disease.code].length
      }
      return 0
    },
    addDisease(disease) {
      const isExist = this.diseaseSelectedList.find(item => {
        if (item.code === disease.code) return item
      })
      if (isExist) return this.$message.error('不能重复添加')

      if (this.model.manyType === '0') {
        this.diseaseSelectedList = [
          {
            ...disease,
            main: true
          }
        ]
      } else {
        const obj = this.diseaseSelectedList.find(item => item.main === true)
        const len = this.diseaseSelectedList.length
        if (len === 0) {
          this.diseaseSelectedList.push({
            ...disease,
            main: true
          })
        } else if (len === 1) {
          if (obj) {
            this.diseaseSelectedList.push({
              ...disease,
              main: false
            })
          } else {
            this.diseaseSelectedList.unshift({
              ...disease,
              main: true
            })
          }
        } else {
          this.diseaseSelectedList.splice(1, 1, {
            ...disease,
            main: false
          })
        }
      }
    },
    async saveDisease() {
      //this.checkList[0].main = true
      const res = await postAction('/projectconfigview/configProject/saveDisease', {
        id: this.model.id, diseaseJson: JSON.stringify(this.checkList), confirm: '0'
      })
      return res
    },
    async loadProjectData() {
      const id = this.$route.query.id
      const res = await getAction('/projectconfigview/configProject/queryById', { id })
      if (res.success) {
        let depts = JSON.parse(res.result.deptJson)
        this.depts = depts
        depts.forEach(item => {
          this.deptIds += item.id + ','
        })
        //this.deptIds = JSON.parse(res.result.deptJson)[0].id
        this.model = res.result
        this.getSubmajor(this.deptIds, this.model.name, '')
      }
    },
    /*获取亚专业 */
    async getSubmajor(deptId, projectName, keyword) {
      const res = await getAction('/projectconfigview/configSubmajor/queryByDeptId', { deptId: deptId, projectName: projectName, keyword: keyword })
      if (res.success) {
        const arr = res.result.otherList
        const arrKey = res.result.keywordList
        arr.forEach(item1 => {
          item1.diseaseList.forEach(item2 => {
            item2.checked = false
            item2.submajorName = item1.name
          })
        })
        arrKey.forEach(item1 => {
          item1.diseaseList.forEach(item2 => {
            item2.checked = false
            item2.submajorName = item1.name
          })
        })
      
        this.subMajor = arr.sort((a, b) => a.deptIds - b.deptIds)
        this.subMajorCopy=this.subMajor
        this.subMajorKeyWords = arrKey
        this.checkList = JSON.parse(this.model.diseaseJson || '[]')
        //数据绑定
        this.checkList.forEach(item1 => {
          this.subMajor.forEach((item2, index2) => {
            item2.diseaseList.forEach((item3, index3) => {
              if (item1.id === item3.id) {
                item3.checked = true
              }
            })
          })
          this.subMajorKeyWords.forEach((item2, index2) => {
            item2.diseaseList.forEach((item3, index3) => {
              if (item1.id === item3.id) {
                item3.checked = true
              }
            })
          })
        })
        //填充页面显示数据
        this.checkList.forEach(item => {
          if (this.checkData.filter(major => major.name === item.submajorName).length > 0) {
            this.checkData.filter(major => major.name === item.submajorName)[0].diseaseList.push(item)
          } else {
            let diseaseList = []
            diseaseList.push(item)
            let temp = { name: item.submajorName }
            temp.diseaseList = diseaseList
            this.checkData.push(temp)
          }
        })
      }
    },

    async search() {
      //this.getSubmajor(this.deptIds, this.model.name, this.keyword)
      //1.查找与关键字匹配的亚专业及对应到的所有病种
      const arr=this.subMajorCopy.filter(item=>item.name.includes( this.keyword))
       //2.查找与关键字匹配的病种及亚专业
       let filterData=this.subMajorCopy.filter(item=>!item.name.includes( this.keyword))
      filterData.forEach(items=>{
        let newList=items.diseaseList.filter(item=>item.name.includes( this.keyword))
        if(newList.length>0){
          items.diseaseList=newList
          arr.push(items)
        }
      })

      this.subMajor=arr
      // console.log(1,this.subMajorCopy)
      // console.log(1,this.subMajor)
      // const res = await getAction('/projectconfigview/configSubmajor/queryByDeptId', { deptId: this.deptIds, projectName: this.model.name, keyword: this.keyword })
      // if (res.success) {
      //   const arr = res.result.otherList
      //   const arrKey = res.result.keywordList
        
      //   // arr.forEach(item1 => {
      //   //   item1.diseaseList.forEach(item2 => {
      //   //     item2.checked = false
      //   //     item2.submajorName = item1.name
      //   //   })
      //   // })
      //    console.log(1,arr)
      //   // arrKey.forEach(item1 => {
      //   //   item1.diseaseList.forEach(item2 => {
      //   //     item2.checked = false
      //   //     item2.submajorName = item1.name
      //   //   })
      //   // })
      //   // this.subMajor = arr
      //   // this.subMajorKeyWords = arrKey

        

      // }
    },
    async nextClick() {
      /* if (this.model.manyType === '0') {
        if (this.diseaseSelectedList.length !== 0) {
          const res = await this.saveDisease();
          if (res.success) {
            this.$message.success(res.message)
            this.$emit('next');
          } else {
            this.$message.error(res.message)
          }
        } else {
          this.$message.warning('请选择病种')
        }
      } else {
        if (this.diseaseSelectedList.length === 2) {
          const res = await this.saveDisease();
          if (res.success) {
            this.$message.success(res.message)
            this.$emit('next');
          } else {
            this.$message.error(res.message)
          }
        } else {
          this.$message.warning('请选择病种')
        }
      } */

      if (this.checkList.length === 0) return this.$message.warning('请选择病种')
      if (this.model.confirm === '1') {
        this.$confirm({
          title: '研究病种确认',
          content: (<div>
            <p>您是否确认将已选择的病种作为队列方案研究病种？</p>
          </div>),
          centered: false,
          onOk: () => {
            this.confirmContent()
          }
        })
      } else {
        this.$emit('next')
      }
    },
    lastClick() {
      this.$emit('last')
    },
    async confirmContent() {
      const res = await this.saveDisease()
      if (res.success) {
        this.$message.success(res.message)
        this.$emit('next')
      } else {
        this.$message.error(res.message)
      }
    },
  }
}
</script>

<style scoped lang="less">
.label {
  color: rgba(0, 0, 0, 0.5);
}

.icon-big {
  font-size: 32px;
}

.delete {
  position: absolute;
  right: 20px;
  top: 15px;
}

.info-title-name {
  margin-left: 10px;
}

.module-names {
  font-size: 12px;
  margin-left: 10px;
  margin-top: 10px;
}

.project-collapse {
  border-color: #575757;
  background: transparent;

  /deep/ .ant-collapse-header {
    color: white;
    background: #373e5d;
  }

  /deep/ .ant-collapse-content {
    background: #1d2132;
    border-top: 1px solid #575757;

    .con-period-edit-panel {
      margin-bottom: 20px;
    }

    .con-period-edit-panel:last-child {
      margin-bottom: 0;
    }
  }

  /deep/ .ant-collapse-item {
    border-bottom: 1px solid #575757;
  }

  /deep/ .ant-collapse-extra {
    margin-top: -4px;
  }
}

.project-template2-card {
  overflow-x: auto;
  white-space: nowrap;

  //display: flex;
  .list {
    width: 100%;
    display: grid;
    // grid-template-columns: repeat(2, 1fr);
    grid-template-columns: repeat(2, 161px);
    grid-gap: 10px;
    justify-content: center;
    margin-top: 12px;

    /deep/ .ant-checkbox-wrapper {
      display: flex;
      align-items: center;
      column-gap: 5px;

      .ant-checkbox {
        margin-left: 10px;
        top: 1px;
      }

      &>span {
        color: white;
        padding: 0;
        display: flex;
        align-items: center;
        column-gap: 5px;

        em {
          color: white;
          font-style: normal;
          padding-right: 10px;
          white-space: break-spaces;
        }
      }
    }

    .item {
      height: 62px;
      display: flex;
      align-items: center;
      position: relative;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 12px;
      margin-left: 0;
      padding: 10px 0;
    }
  }
}

.info-title {
  padding-top: 40px;
  padding-bottom: 40px;
  margin-top: 10px;
  margin-bottom: 10px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 16px;
  color: white;
  background-color: #2f3b52;
  position: relative;
}

.info-title-disease1 {
  padding-top: 20px;
  padding-bottom: 20px;
}

.info-title-center {
  text-align: center;
}

.info-title-dept {
  text-align: center;
}

.icon-big-dept {
  font-size: 32px;
}

.info-title-no {
  border: 1px dashed rgba(0, 0, 0, 0.2) !important;
}

.info-title2 {
  padding-top: 12px;
  padding-bottom: 12px;
  margin-top: 10px;
  margin-bottom: 10px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: #2f3b52;
  color: white;
  border-radius: 10px;
  position: relative;
}

.info-mini-title {
  margin-top: 10px;
  margin-left: 10px;
  color: white;
}

.small-title {
  font-weight: 600;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 21px;

  img {
    vertical-align: sub;
  }
}

.temp2-disease-title {
  font-size: 18px;
  color: white;
}

.search-panel {
  .search-input {
    width: 400px;
    color: white;
    border: 1px solid rgba(0, 0, 0, 0.2);
    background: rgba(255, 255, 255, 0.15);
  }

  margin-bottom: 20px;
}


.gauge {
  padding: 15px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px 12px 12px 12px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  margin-bottom: 20px;

  .title1 {
    display: flex;
    align-items: center;

    h2 {
      font-size: 18px;
      color: white;
      margin: 0 10px 0 0;
    }

    span {
      font-weight: 400;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.7);
    }

    .select-all {
      margin-left: auto;

      /deep/ .ant-checkbox-wrapper {
        span {
          color: white;

        }
      }

      /deep/ .ant-checkbox-checked .ant-checkbox-inner {
        background-color: #376eff;
        border-color: #376eff;
      }

      /deep/ .ant-checkbox-indeterminate .ant-checkbox-inner::after {
        background-color: #376eff;
      }
    }
  }

  .list {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 10px;
    justify-content: center;
    margin-top: 12px;

    /deep/ .ant-checkbox-wrapper {
      display: flex;
      align-items: center;
      column-gap: 5px;

      .ant-checkbox {
        margin-left: 10px;
        top: 1px;
      }

      &>span {
        color: white;
        padding: 0;
        display: flex;
        align-items: center;
        column-gap: 5px;

        em {
          font-style: normal;
          padding-right: 10px;
        }
      }
    }

    /deep/ .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #376eff;
      border-color: #376eff;
    }

    .item {
      height: 62px;
      display: flex;
      align-items: center;
      position: relative;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 12px;
      margin-left: 0;
      padding: 10px 0;
    }

    .info {
      margin-left: 35px;

      .line1 {
        strong {
          font-weight: 600;
          font-size: 14px;
          color: #FFFFFF;
        }

        span {
          display: inline-block;
          font-weight: 400;
          font-size: 12px;
          color: #FFFFFF;
          padding: 3px 5px;
          margin-left: 5px;
          background: #343546;
          border-radius: 4px;
        }
      }

      .line2 {
        padding: 3px 0;

        dl {
          display: flex;
          margin: 0;
          align-items: center;
        }

        dt {
          font-weight: 400;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.4);
          line-height: 14px;
          word-break: keep-all
        }

        dd {
          font-weight: 400;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.7);
          line-height: 16px;
          margin: 0 0 0 10px;
        }

        /deep/ .ant-rate {
          font-size: 12px;
        }
      }
    }
  }
}


.project-disease-check {
  padding: 10px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px 12px 12px 12px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  margin-bottom: 20px;

  .title1 {
    display: flex;
    align-items: center;

    h2 {
      font-size: 18px;
      color: white;
      margin: 0 10px 0 0;
    }

    span {
      font-weight: 400;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.7);
    }

    .select-all {
      margin-left: auto;

      /deep/ .ant-checkbox-wrapper {
        span {
          color: white;

        }
      }

      /deep/ .ant-checkbox-checked .ant-checkbox-inner {
        background-color: #376eff;
        border-color: #376eff;
      }

      /deep/ .ant-checkbox-indeterminate .ant-checkbox-inner::after {
        background-color: #376eff;
      }
    }
  }

  .list {
    width: 100%;
    display: grid;
    // grid-template-columns: repeat(2, 1fr);
    grid-template-columns: repeat(2, 161px);
    grid-gap: 10px;
    justify-content: center;
    margin-top: 12px;

    /deep/ .ant-checkbox-wrapper {
      display: flex;
      align-items: center;
      column-gap: 5px;

      .ant-checkbox {
        margin-left: 10px;
        top: 1px;
      }

      &>span {
        color: white;
        padding: 0;
        display: flex;
        align-items: center;
        column-gap: 5px;

        em {
          color: white;
          font-style: normal;
          padding-right: 10px;
          white-space: break-spaces;
        }
      }
    }

    .item {
      height: 62px;
      display: flex;
      align-items: center;
      position: relative;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 12px;
      margin-left: 3px;
      padding: 10px 0;
    }
  }
}
</style>
